import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import "./lib/installCsrfAxios";
import "./index.css";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";
import './i18n';
import { installPilotDiagnostics } from "./lib/pilotDiagnostics";

installPilotDiagnostics();

createRoot(document.getElementById("root")).render(
  <ErrorBoundary name="root">
    <Router>
      <App />
    </Router>
  </ErrorBoundary>
);
